/**
 * Announcement bar rotation (AB#523).
 *
 * Cross-fades between the rendered lines. The market-aware shipping line is index 0 and is
 * always shown first, so a visitor who looks once sees the shipping answer rather than a patch
 * offer.
 *
 * REDUCED MOTION STOPS THE ROTATION ENTIRELY, it does not merely shorten the fade. A bar that
 * swaps its own text every few seconds is the kind of involuntary movement the preference
 * exists to prevent, and a shortened fade would still move the content. The first line stays.
 *
 * The same is true of the owner's static-mode setting, so both paths share one code path.
 *
 * Hidden lines keep the `hidden` attribute rather than `opacity: 0`, so they are out of the
 * accessibility tree too. Three competing announcements read in sequence is worse than one.
 */

const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

function setup(bar) {
  const lines = [...bar.querySelectorAll('.mlr-announcement__line')];
  if (lines.length < 2) return;

  const wantsRotation = bar.dataset.mlrRotate === 'true';
  const speed = Number(bar.dataset.mlrSpeed) || 3800;

  let timer = null;
  let index = 0;

  const show = (next) => {
    lines.forEach((line, i) => {
      const active = i === next;
      line.hidden = !active;
      line.classList.toggle('mlr-announcement__line--in', active);
    });
    index = next;
  };

  const stop = () => {
    if (timer) window.clearInterval(timer);
    timer = null;
  };

  const start = () => {
    stop();
    if (!wantsRotation || REDUCED.matches) {
      // Static: the first line, and nothing moving.
      show(0);
      return;
    }
    show(index);
    timer = window.setInterval(() => show((index + 1) % lines.length), speed);
  };

  // A rotation nobody is looking at is wasted work and a wasted wakeup on a phone.
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop();
    else start();
  });

  // Respond to the preference changing without a reload.
  REDUCED.addEventListener('change', start);

  start();
}

for (const bar of document.querySelectorAll('.mlr-announcement')) setup(bar);
